import PropTypes from "prop-types";

export const LinksListItemType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  popover: PropTypes.node,
});
